import React from "react";
import { NavLink, Route, Routes, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Logout } from "../../../store/action";
// import Chart from "../main";
// import SMS from "../SMS";
// import Email from "../email";
import Comment from "../comment";
import NotFound from "../../notFound";

const Layout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logOutHandler = async () => {
    dispatch(Logout());
    // return window.location.assign("/");
    navigate("/admin", { replace: true });
  };
  return (
    <div
      className=" bg-white text-gray-700 w-full font-IRANSansWeb mx-auto flex flex-row-reverse pt-10 screen800:flex-col
     screen800:text-[14px]"
    >
      <div
        className="w-[20%]  mx-3  screen800:w-[85%] screen800:mx-auto  screen500:text-[13px] screen800:border-b-2 screen800:pb-8
       border-gray-300 border-dashed"
      >
        <div className="flex flex-col gap-14 mt-20  screen800:flex-row-reverse screen800:my-0  screen330:gap-[7px] screen800:gap-5 font-bold  ">
          <NavLink
            className={({ isActive }) =>
              isActive ? "text-[#f8be13]" : "text-[#629459]"
            }
            to="/admin"
          >
            لیست نظرات
          </NavLink>
          <NavLink
            className="hover:text-green-600 screen800:mr-6"
            onClick={logOutHandler}
            to="/admin"
            replace={true}
          >
            خروج
          </NavLink>
        </div>
      </div>

      <div className="w-[80%] fontIRANSansWeb  px-10 border-r-2 border-dashed border-gray-300 screen800:w-full screen500:px-1 screen800:border-r-0 ">
        <Routes>
          <Route exact path="/" element={<Comment />} />

          <Route path="*" element={<Navigate to="#/admin" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </div>
  );
};

export default Layout;
